import axios from 'axios';
import config from '../config/config';
import { getAuthHeaders } from '../utils/authUtils'; // Import the utility function

export const fetchDepartments = async () => {
  try {
    const response = await axios.get(`${config.apiBaseUrl}/api/departments`, {
      headers: getAuthHeaders(),
    });
    //console.log('Department Details:', response.data); // Log the data to verify
    return response.data;
  } catch (error) {
    console.error('Error fetching departments:', error);
    throw error;
  }
};

export const saveDepartment = async (department) => {
  try {
    const headers = getAuthHeaders();
    if (department.departmentId) {
      await axios.put(`${config.apiBaseUrl}/api/departments/${department.departmentId}`, department, { headers });
    } else {
      await axios.post(`${config.apiBaseUrl}/api/departments`, department, { headers });
    }
  } catch (error) {
    console.error('Error saving department:', error);
    throw error;
  }
};

export const deleteDepartment = async (departmentId) => {
  try {
    const headers = getAuthHeaders();
    await axios.delete(`${config.apiBaseUrl}/api/departments/${departmentId}`, { headers });
  } catch (error) {
    console.error('Error deleting department:', error);
    throw error;
  }
};